import script from "./JogosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JogosPage.vue?vue&type=script&setup=true&lang=js"

import "./JogosPage.vue?vue&type=style&index=0&id=c6e469b6&lang=css"

const __exports__ = script;

export default __exports__